import { AxiosRequestConfig } from 'axios'
import SimulationECPFRepository from 'ecpf/repositories/SimulationECPFRepository'

export class SimulationService {
  async validateMaxSolicitation (config?: AxiosRequestConfig) {
    return SimulationECPFRepository.validateMaxSolicitation(config)
  }
}
